// src/services/tapfiliateService.ts
import Tap from '@tapfiliate/tapfiliate-js';

let isInitialized = false; // Track initialization status

export const initializeTapfiliate = (): void => {
  if (!isInitialized) {
    const accountId = process.env.REACT_APP_TAPFILIATE_ACCOUNT_ID;

    if (!accountId) {
      throw new Error(
        'Tapfiliate account ID is missing. Set it in your environment variables.',
      );
    }

    // Initialize Tapfiliate
    Tap.init(accountId);
    console.log('Tapfiliate initialized with account ID:', accountId);

    isInitialized = true; // Set initialized flag
  }
};

export const trackConversion = (orderId: string, amount: number): void => {
  if (!isInitialized) {
    console.error('Tapfiliate has not been initialized.');
    return;
  }

  // Call the create method on the conversion object
  Tap.conversion.create({
    order_id: orderId,
    amount: amount,
  });

  console.log(`Conversion tracked: Order ID ${orderId}, Amount ${amount}`);
};

/**
 * Tracks a custom event.
 * @param eventName - The name of the custom event.
 * @param customData - Additional data related to the event.
 */
export const trackCustomEvent = (
  eventName: string,
  customData?: Record<string, unknown>,
): void => {
  if (!isInitialized) {
    console.error('Tapfiliate has not been initialized.');
    return;
  }
  Tap.event.create({
    event_name: eventName,
    ...customData,
  });
  console.log(`Custom event tracked: ${eventName}`, customData);
};
